/* ROMANTICO - Size guide modal (native <dialog>) opener/closer.
   Any element with [data-size-guide-open] opens the first .size-guide__dialog;
   [data-size-guide-close] or a backdrop click closes it. */
(function () {
  if (window.__romSizeGuide) return;
  window.__romSizeGuide = true;

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-size-guide-open]');
    if (open) {
      e.preventDefault();
      var d = document.querySelector('.size-guide__dialog');
      if (d) {
        if (typeof d.showModal === 'function') d.showModal();
        else d.setAttribute('open', '');
      }
      return;
    }
    var close = e.target.closest('[data-size-guide-close]');
    if (close) {
      var dd = close.closest('.size-guide__dialog');
      if (dd) dd.close();
      return;
    }
    if (e.target.classList && e.target.classList.contains('size-guide__dialog')) {
      e.target.close();
    }
  });
})();
